export default __webpack_public_path__ + "static/media/interpreter-profile.d9729c99.svg";